import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { QRCodeSVG } from 'qrcode.react';

const QR_SIZE = 180;

// QR-код для регистрации студентов + скачивание в PNG.
export default function CampQr({ value }) {
    const boxRef = useRef(null);

    const handleDownload = () => {
        const svg = boxRef.current?.querySelector('svg');
        if (!svg) return;

        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const img = new Image();

        img.onload = () => {
            canvas.width = QR_SIZE;
            canvas.height = QR_SIZE;
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, QR_SIZE, QR_SIZE);
            ctx.drawImage(img, 0, 0, QR_SIZE, QR_SIZE);
            const link = document.createElement('a');
            link.download = 'qr-code-camp.png';
            link.href = canvas.toDataURL('image/png');
            link.click();
        };
        img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)));
    };

    return (
        <div className="qr-wrap">
            <div className="qh">QR-код для студентов</div>
            <div className="qr-box" ref={boxRef}>
                <QRCodeSVG value={value} size={QR_SIZE} level="M" includeMargin={false} />
            </div>
            <button type="button" className="btn btn-success" onClick={handleDownload}>
                Скачать QR
            </button>
        </div>
    );
}

CampQr.propTypes = {
    value: PropTypes.string.isRequired
};
